import { h } from 'preact'
import UserAvatar from '../../User/UserAvatar'

const UserCell = (accessor: string) => {
  return (props: any) => {
    const userFromProps = props[accessor]
    if (!userFromProps) {
      return null
    }

    const { id, username, avatar } = userFromProps
    const user = {
      id,
      name: username,
      avatar,
      url: `/member/profile?userid=${id}`
    }

    return (
      <div className='overview__table-user'>
        <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{username}</a>
      </div>
    )
  }
}

export default UserCell
